import * as React from 'react'

function VmPDewasaGrayIcon({title, titleId, ...props}, svgRef) {
  return React.createElement(
    'svg',
    Object.assign(
      {
        id: 'Layer_1',
        'data-name': 'Layer 1',
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 461 459',
        ref: svgRef,
        'aria-labelledby': titleId,
      },
      props
    ),
    title
      ? React.createElement(
          'title',
          {
            id: titleId,
          },
          title
        )
      : null,
    React.createElement('path', {
      d: 'M8027,3880.28v37a36.32,36.32,0,0,0-1,4.33,222.54,222.54,0,0,1-32,95.72C7967.56,4060.5,7931,4092,7884,4111.21c-1.27-3-2.22-6.26-3.84-9.1-13.18-23-32.65-40.41-52.1-57.81l-1-5c.42-5.05-1.48-11.18,6-13,44.74-1.91,75-35.78,70.71-80.19-2.61-27.14-6.42-54.17-9.86-81.23-.21-1.68-1.94-3.16-3-4.74,2.25-.57,4.5-1.16,6.76-1.69,7-1.64,7.84-2.1,7.18-9.44-1-11.41-2-22.91-4.37-34.1-5.88-28.14-23.11-45.61-51.15-52.66-17.1-4.3-34.37-6.56-51.93-5.78-22.84,1-45.06,5-65.18,16.65-4.27,2.47-5.94,1.9-8-2.57-8.67-18.53-28.13-29.31-47.65-26.89-25.34,3.14-43.55,24.21-42.4,49.06,1.16,25.09,20.84,44.35,46.38,45.38,6.59.26,7,.3,6.39,6.78-1.5,16.66,3.37,31.66,11.58,45.73,4.52,7.75,9.77,15.08,14.69,22.6-7.87,1.91-12.48,7-14.83,14.63-5,16.14,5.31,41.12,20.27,48.88,5.88,3,12.06,4.53,18.18,1.39,4.49-2.3,6.4-.91,8.36,3.18,5.55,11.56,13.06,21.81,23.7,29.09,5.61,3.84,8,8.52,8.06,14.91,0,1.66.09,3.33.14,5l-.12,6.07c-1.63-2.8-3.47-1.51-5.43-.36q-14.2,8.26-28.45,16.42c-7.62,4.39-15.43,8.48-22.83,13.21-6.45,4.13-12.35,9.05-15.35,16.52a44,44,0,0,0-3.79,4.59c-3.4,5.41-6.64,10.93-9.94,16.4-66.82-35.94-107.42-91.11-121.27-165.76-1.72-9.28-2.57-18.73-3.82-28.11v-21c.6-4.44,1.35-8.86,1.79-13.31,9.82-98.69,83.34-180.46,180.71-200.79,9.75-2,19.66-3.29,29.5-4.9h37c6.4,1,12.81,1.91,19.21,2.92,92.47,14.49,168.82,87,187.86,178.6C8024.1,3860.55,8025.37,3870.45,8027,3880.28Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#ababab',
      },
    }),
    React.createElement('path', {
      d: 'M7884,4111.21c-20.25,8.64-41.44,13.58-63.25,16.06a47.22,47.22,0,0,0-4.71,1h-40l-8.27-1.81c1.08-2.09,2.76-4.1,3.09-6.31a64.33,64.33,0,0,0,.16-11c-.46-17.84-11.71-30.15-29.33-33-13-2.1-25.1.53-36.82,5.94,3-7.47,8.9-12.39,15.35-16.52,7.4-4.73,15.21-8.83,22.83-13.21q14.24-8.19,28.45-16.42c2-1.14,3.8-2.44,5.43.36.08,5.32.25,10.63.22,15.95-.05,8.19,4.11,13.45,11.39,16.46a36.32,36.32,0,0,0,22.51,1.51c12.1-2.79,16.74-8.63,16.88-21,0-1.66.09-3.32.14-5,19.45,17.4,38.91,34.79,52.1,57.81C7881.75,4105,7882.7,4108.17,7884,4111.21Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#777',
        stroke: '#777',
      },
    }),
    React.createElement('path', {
      d: 'M7713.12,3913.23c-4.92-7.52-10.16-14.85-14.69-22.6-8.21-14.07-13.08-29.07-11.58-45.73.58-6.48.21-6.52-6.39-6.78-25.53-1-45.21-20.28-46.38-45.38-1.15-24.85,17.06-45.92,42.4-49.06,19.52-2.42,39,8.36,47.65,26.89,2.09,4.47,3.77,5,8,2.57,20.11-11.67,42.34-15.64,65.18-16.65,17.57-.78,34.84,1.48,51.93,5.78,28,7.05,45.27,24.52,51.15,52.66,2.34,11.19,3.35,22.69,4.37,34.1.66,7.34-.16,7.8-7.18,9.44-2.26.53-4.51,1.13-6.76,1.69l-9.6,1.82c1.69,5.35-.94,5.27-4.85,5-5.57-.37-11.2.15-16.81.3a30.11,30.11,0,0,1-4.38.17c-3.16-.38-6.3-1.53-9.42-1.43-32.87,1-64.75-3.21-94.85-17.28-1.27-.6-2.61-1.05-5.06-2,6.71,20,6.75,39.19,2,58.46l-10.54,25.42c-6.21-7.68-12.74-12.27-20.85-14.55C7715.24,3915.68,7714.25,3914.2,7713.12,3913.23Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#363636',
      },
    }),
    React.createElement('path', {
      d: 'M7747.92,3905.18c4.7-19.28,4.66-38.46-2-58.46,2.45,1,3.79,1.43,5.06,2,30.11,14.07,62,18.3,94.85,17.28,3.12-.1,6.27,1,9.42,1.43a30.11,30.11,0,0,0,4.38-.17c5.61-.15,11.24-.67,16.81-.3,3.92.26,6.55.33,4.85-5l9.6-1.82c1,1.58,2.75,3.06,3,4.74,3.44,27.06,7.26,54.09,9.86,81.23,4.26,44.4-26,78.28-70.71,80.19-32.48-1.47-56.58-16.2-70.17-46-3.92-8.61-5.45-18.44-7.21-27.88C7752.67,3936.75,7750.45,3920.94,7747.92,3905.18Zm44.91,39.81-.34-.66c-5,1.52-10.13,2.77-15,4.72-1.36.55-2.5,3.08-2.6,4.78-.06,1,1.85,2.81,3.19,3.21,8.08,2.42,15.85,1.06,23-3.17,3.59-2.13,3-6.09-1-7.58C7797.84,3945.44,7795.27,3945.4,7792.83,3945Zm95.06-20.15c-5.94,2.19-11.41,3.94-16.59,6.32-1.32.61-2.48,3.3-2.3,4.88.14,1.21,2.55,3.14,3.86,3.07a95.37,95.37,0,0,0,17.09-2.09c3.31-.79,8.08-2.65,6.6-7.1C7895.79,3927.66,7891.24,3926.68,7887.9,3924.84ZM7842,3977l-.16-.73a17,17,0,0,0-3-.26c-1.56.13-3.11.47-4.66.72.35,1.69.26,3.67,1.13,5,3.41,5.28,8.49,7.31,14.64,6.28a13.2,13.2,0,0,0,11.19-10.07c1.18-4.14,0-5.13-4.17-4.15C7852,3974.93,7847,3975.9,7842,3977Zm1.76-34.64c2.37.86,3.35,1.54,4.33,1.52,5.69-.08,10.73-5,10.81-10.37.1-6.13-3.62-10-10.34-10-3.75,0-5.34-1.71-6.34-5-1.61-5.25-3.36-10.46-5.23-15.62a29.55,29.55,0,0,0-2.65-4.6l-1.61.53c.15,1.81,0,3.72.49,5.41,2,6.52,4.32,12.94,6.36,19.45,1.19,3.81,3.15,5.59,7.36,4.33,3.52-1.06,6.33.16,7.42,3.89s-1,5.59-4,7C7848.52,3939.75,7846.76,3940.74,7843.76,3942.31Zm17.81-35.05c.91-2.4,1.73-4.84,2.74-7.2,4.66-10.89,10.91-11.72,18.21-2.48,1.25,1.58,2.49,3.18,3.74,4.76l1.66-1c-2.57-4.65-4.55-9.8-7.87-13.84a10.38,10.38,0,0,0-16.45.76C7859.64,3894,7859.71,3900.51,7861.56,3907.26Zm-78.36,14,1.34.31c1.69-3.93,3-8,5.14-11.74,3.72-6.56,8.26-7,13.63-1.77,2.12,2.08,4,4.41,6,6.63l1.48-1c-2.07-4-3.62-8.42-6.33-11.93-5.78-7.49-16.49-5.63-19.19,3.44C7783.73,3910.3,7783.83,3915.88,7783.21,3921.25Zm10.65-41.59c-2.51-1-3.8-2.09-4.91-1.94a35.6,35.6,0,0,0-20.34,9.58c-.83.81-.74,2.58-1.07,3.9,1.45-.13,3.06.1,4.31-.47,5.83-2.63,11.57-5.46,17.31-8.27C7790.36,3881.89,7791.46,3881.1,7793.85,3879.66Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#c8c8c8',
      },
    }),
    React.createElement('path', {
      d: 'M7747.92,3905.18c2.52,15.76,4.75,31.57,7.68,47.26,1.76,9.43,3.29,19.27,7.21,27.88,13.58,29.8,37.69,44.53,70.17,46-7.46,1.81-5.56,7.94-6,13-8.44,3.88-16.87,3.81-25.47.35-8.11-3.27-16.34-6.25-24.52-9.35,0-1.66-.12-3.33-.14-5-.07-6.39-2.45-11.06-8.06-14.91-10.63-7.28-18.15-17.52-23.7-29.09-2-4.09-3.87-5.48-8.36-3.18-6.12,3.13-12.3,1.65-18.18-1.39-15-7.76-25.23-32.73-20.27-48.88,2.35-7.65,7-12.72,14.83-14.63,1.13,1,2.12,2.45,3.41,2.82,8.1,2.28,14.63,6.87,20.85,14.55Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#afafaf',
        stroke: '#afafaf',
      },
    }),
    React.createElement('path', {
      d: 'M7704.82,4082.15c11.72-5.41,23.78-8,36.82-5.94,17.62,2.84,28.87,15.16,29.33,33a64.33,64.33,0,0,1-.16,11c-.32,2.21-2,4.21-3.09,6.31-27-2.84-52.43-11.15-76.64-23.33,3.3-5.47,6.54-11,9.94-16.4A44,44,0,0,1,7704.82,4082.15Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#6f6f6f',
        stroke: '#6f6f6f',
      },
    }),
    React.createElement('path', {
      d: 'M7777,4030.3c8.18,3.11,16.41,6.09,24.52,9.35,8.59,3.46,17,3.53,25.47-.35l1,5c0,1.66-.12,3.32-.14,5-.14,12.37-4.78,18.2-16.88,21a36.32,36.32,0,0,1-22.51-1.51c-7.27-3-11.44-8.27-11.39-16.46,0-5.31-.14-10.63-.22-15.95Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#c8c8c8',
        stroke: '#c8c8c8',
      },
    }),
    React.createElement('path', {
      d: 'M7792.83,3945c2.44.41,5,.45,7.28,1.3,4,1.49,4.55,5.45,1,7.58-7.12,4.23-14.9,5.59-23,3.17-1.34-.4-3.25-2.18-3.19-3.21.1-1.69,1.24-4.23,2.6-4.78,4.84-1.95,10-3.2,15-4.72Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#bfbfbf',
        stroke: '#bfbfbf',
      },
    }),
    React.createElement('path', {
      d: 'M7887.9,3924.84c3.35,1.84,7.89,2.82,8.65,5.07,1.48,4.45-3.29,6.31-6.6,7.1a95.37,95.37,0,0,1-17.09,2.09c-1.31.07-3.72-1.86-3.86-3.07-.18-1.58,1-4.27,2.3-4.88C7876.49,3928.78,7882,3927,7887.9,3924.84Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#bfbfbf',
        stroke: '#bfbfbf',
      },
    }),
    React.createElement('path', {
      d: 'M7842,3977c5-1.05,10-2,15-3.18,4.22-1,5.35,0,4.17,4.15A13.2,13.2,0,0,1,7850,3988c-6.14,1-11.23-1-14.64-6.28-.87-1.35-.78-3.33-1.13-5,1.55-.25,3.1-.59,4.66-.72a17,17,0,0,1,3,.26Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#fefefe',
      },
    }),
    React.createElement('path', {
      d: 'M7843.76,3942.31c3-1.58,4.76-2.57,6.58-3.44,3-1.43,5.07-3.42,4-7s-3.9-4.95-7.42-3.89c-4.21,1.26-6.17-.52-7.36-4.33-2-6.51-4.35-12.94-6.36-19.45-.52-1.69-.35-3.6-.49-5.41l1.61-.53a29.55,29.55,0,0,1,2.65,4.6c1.87,5.16,3.63,10.37,5.23,15.62,1,3.25,2.58,4.94,6.34,5,6.72,0,10.44,3.92,10.34,10-.09,5.38-5.12,10.29-10.81,10.37C7847.11,3943.85,7846.13,3943.18,7843.76,3942.31Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#afafaf',
      },
    }),
    React.createElement('path', {
      d: 'M7861.56,3907.26c-1.86-6.76-1.92-13.25,2-19a10.38,10.38,0,0,1,16.45-.76c3.32,4,5.3,9.19,7.87,13.84l-1.66,1c-1.24-1.59-2.48-3.18-3.74-4.76-7.3-9.25-13.55-8.41-18.21,2.48C7863.29,3902.42,7862.47,3904.86,7861.56,3907.26Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#373737',
      },
    }),
    React.createElement('path', {
      d: 'M7783.21,3921.25c.63-5.36.53-10.95,2-16,2.7-9.07,13.41-10.93,19.19-3.44,2.71,3.51,4.26,7.93,6.33,11.93l-1.48,1c-2-2.22-3.85-4.55-6-6.63-5.36-5.27-9.9-4.78-13.63,1.77-2.1,3.7-3.45,7.81-5.14,11.74Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#373737',
      },
    }),
    React.createElement('path', {
      d: 'M7793.85,3879.66c-2.39,1.44-3.49,2.23-4.69,2.81-5.75,2.81-11.49,5.64-17.31,8.27-1.25.57-2.86.33-4.31.47.33-1.33.23-3.1,1.07-3.9a35.6,35.6,0,0,1,20.34-9.58C7790.06,3877.57,7791.34,3878.63,7793.85,3879.66Z',
      transform: 'translate(-7566 -3669.28)',
      style: {
        fill: '#373737',
      },
    })
  )
}

const ForwardRef = React.forwardRef(VmPDewasaGrayIcon)
export default ForwardRef
